
interface Product {
  name: string;
  id: string;
  selected: boolean;
  description: string;
}

import Vue from 'vue';
import axios from 'axios';
import StepOne from './StepOne.vue';
import StepTwo from './StepTwo.vue';
import StepThree from './StepThree.vue';
import StepFour from './StepFour.vue';

export default Vue.extend({
  name: 'MoveForm',
  components: {
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
  },
  data() {
    return {
      inquiry: process.env.VUE_APP_INQUIRY as string,
      page: 1,
      errors: [''],
      isSolarWantedByCustomer: false,
      isChargerWantedByCustomer: false,
      userInfo: {
        solar: false,
        charger: false,
        name: '',
        email: '',
        phone: '',
        businessName: '',
        businessOrgNumber: '',
        fromAddress: '',
        fromZip: '',
        fromDate: '',
        toAddress: '',
        toZip: '',
        toDate: '',
        meterid: '',
        endInvoice: '',
        isBusinessUser: false,
        userDescription: '',
        continuePayment: false,
        products: [
          {
            name: 'Alle dine tjenester og produkter',
            id: 'alle',
            selected: false,
            description:
              'Vi overfører alle produkter du har hos oss. <br/>Det kan påløpe kostnader ved installasjon av Altibox på din nye adresse, forutsatt at vi kan levere tjenesten på adressen. Kundeservice vil ta kontakt med deg for å fullføre bestillingen.',
          },
          {
            name: 'Strømavtale',
            id: process.env.VUE_APP_PRODUCT_STROM,
            selected: false,
            description:
              'Hvis du har en strømavtale fra før, overfører vi avtalen til ny adresse. Dersom du ikke har en avtale hos oss, er standardvalget Følg markedet. <br/> <a href="https://hkraft.no/strom/vare-stromavtaler/folg-markedet/" target="_blank">Les betingelser </a>',
          },
          {
            name: 'TV, internett og / eller telefon',
            id: process.env.VUE_APP_PRODUCT_INTERNETTTV,
            selected: false,
            description:
              'Har du en Altibox avtale med internett og TV i dag og vi kan levere på din nye adresse, overfører vi avtalen kostnadsfritt dersom du er medlem av HK Kundeklubb. Ikke medlem eller ved bestilling av kun internett: kr 550,-.<br/>Dersom det ikke er installert Altibox på din nye adresse og vi kan levere vil det påløpe installasjonskostnader. Kundeservice vil da ta kontakt med deg for å fullføre bestillingen på din nye adresse.',
          },
        ] as Product[],
      },
    };
  },
  methods: {
    scrollToTop(): void {
      // @ts-ignore
      document.querySelector('#app').scrollIntoView();
    },
    setPage(id: number): void {
      this.page = id;
      this.scrollToTop();
    },
    send(o: any): void {
      if (o) {
        Object.assign(this.userInfo, o);
      }
      this.save();
    },
    savepoint(data: any, newPage: number): void {
      if (data) {
        Object.assign(this.userInfo, data);
      }
      this.setPage(newPage);
    },
    save(): void {
      const customerType = this.userInfo.isBusinessUser
        ? 'Bedriftskunde'
        : 'Privatkunde';

      const postData = { description: '' } as any;
      postData.name = this.userInfo.name;
      postData.phone = this.userInfo.phone;
      postData.email = this.userInfo.email;
      postData.subject = `Kunde ønsker å flytte: ${this.userInfo.name} ${customerType} (innmeldt på hkraft.no)`;

      if (this.userInfo.isBusinessUser) {
        postData.description = `Bedrift: ${this.userInfo.businessName} \n OrgNr: ${this.userInfo.businessOrgNumber} \n\n`;
      }

      postData.description += `Navn: ${this.userInfo.name} \n Flytter fra: ${this.userInfo.fromAddress} ${this.userInfo.fromZip}. Utflyttingsdato: ${this.userInfo.fromDate}.`;

      if (this.userInfo.toAddress) {
        postData.description += `\nFlytter til: ${this.userInfo.toAddress} ${this.userInfo.toZip}. Innflyttingsdato: ${this.userInfo.toDate}.`;

        const selectedProducts = this.userInfo.products.filter(
          (p: Product) => p.selected === true && p.id !== 'alle'
        );

        const isSelectedAllOption =
          this.userInfo.products.filter(
            (p: Product) => p.selected === true && p.id === 'alle'
          ).length > 0;
        // TODO add tag manager for customer where they choose All and atleast 1 other product
        if (isSelectedAllOption || selectedProducts.length !== 0) {
          postData.description += `\n\nØnsker følgende produkter på ny adresse:`;
          selectedProducts.forEach((product: Product) => {
            postData[product.id] = 1;
            postData.description += `\n- ${product.name}`;
          });

          if (isSelectedAllOption) {
            postData.description += '\n- Alle eksisterende produkter.';
          }
          if (!isSelectedAllOption && selectedProducts.length === 0) {
            postData.description += '\n- Alle eksisterende produkter.';
          }
        } else {
          postData.description +=
            '\n (Kunden har ikke valgt noen spesifikke produkter for ny adresse)';
        }
      } else {
        postData.description += `\n\nKunde ønsker ikke tjeneste på ny adresse.`;
        postData.description += `\nSend opphørsfaktura til: ${this.userInfo.endInvoice}`;
      }

      if (this.userInfo.meterid) {
        postData.description += `\nNy målerid: ${this.userInfo.meterid}`;
      }

      if (this.userInfo.solar || this.userInfo.charger) {
        postData.description += `\n\nKunde har følgende fastmontert anlegg:`;
        if (this.userInfo.solar) {
          postData.description += `\n- Solceller`;
        }
        if (this.userInfo.charger) {
          postData.description += `\n- Elbillader`;
        }

        if (this.userInfo.continuePayment) {
          postData.description += `\nJeg ønsker å overføre nedbetalingen til en annen strømavtale.`;
        }
      }

      postData.description += `\n\n${this.userInfo.userDescription}`;

      postData[this.inquiry] = 'Flytte eller endre avtale';

      let pd = '';
      Object.keys(postData).forEach((key) => {
        if (pd.length > 1) {
          pd += '&';
        }
        pd += `${key}=${encodeURI(postData[key])}`;
      });

      // @ts-ignore
      this.$gtm.trackEvent({
        event: 'submit_move_form',
        category: 'Flytting',
        action: this.userInfo.isBusinessUser ? 'B2B' : 'B2C',
        label: 'Kundeservice Flytteskjema',
        customerType: this.userInfo.isBusinessUser ? 'B2B' : 'B2C',
      });
      const http = axios.create({
        baseURL: process.env.VUE_APP_BACKEND_URL,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      http.post('', pd);
      this.setPage(4);
    },
  },
});
